import { useSyncExternalStore } from "react";

export function useClientFlag(read: () => boolean): boolean {
    return useSyncExternalStore(
        (listener) => {
            window.addEventListener("storage", listener);
            return () => window.removeEventListener("storage", listener);
        },
        read,
        () => true,
    );
}
